import Settings from 'Settings'
import {ensureUrlCorrectSlashes} from '@daedalus/core/src/utils/url'

// Ensures that public url always has a trailling slash
export const publicUrl = ensureUrlCorrectSlashes([Settings.get('PUBLIC_URL')])

export default {
  search: Settings.get('REACT_APP_SEARCH_ENDPOINT'),
  hotelSearch: ensureUrlCorrectSlashes([
    Settings.get('REACT_APP_SEARCH_ENDPOINT'),
    '/Hotel/Search'
  ]),
  publicUrl
}
